import { NotesSection } from "./notes";
import { OutingsInfo } from "./outingsInfo";
import { ListingTable } from "./listingsTable";
import { Dropdown } from "../../common/dropDown";
import { TextInput } from "../../common/textInput";
import { formatPrice } from "../../../utils/formatPrice";
import { CurrencyInput } from "../../common/currencyInput";
import { Box, Typography, Paper, Grid2 } from "@mui/material";
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber";
import { convertToFormattedAmount } from "../../../utils/convertAmount";
import type { BuyerProfile } from "../../../interfaces/buyerProfileInterface";

const options = [
  { label: "None", value: "" },
  { label: "Jane Doe", value: 1 }
];

interface BuyerProfileSectionProps {
  buyerId: string;
  buyerData: BuyerProfile;
}

export const BuyerProfileSection = ({
  buyerId,
  buyerData
}: BuyerProfileSectionProps) => {
  return (
    <Box sx={{ my: 5 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {buyerData.buyer.firstName} {buyerData.buyer.lastName}
      </Typography>
      <Box sx={{ mt: 1 }}>
        <Typography variant="body2" sx={{ color: "gray" }}>
          <strong>Created At:</strong>{" "}
          {buyerData.buyer.createdAt
            ? new Date(buyerData.buyer.createdAt)
                .toLocaleString("en-US", {
                  timeZone: "America/New_York",
                  weekday: "short",
                  year: "numeric",
                  month: "short",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true
                })
                .replace(",", "")
                .replace(/(\d+:\d+ [APM]+)$/, "at $1")
            : ""}
        </Typography>
        <Typography variant="body2" sx={{ color: "gray" }}>
          <strong>Last Updated:</strong>{" "}
          {buyerData.buyer.updatedAt
            ? new Date(buyerData.buyer.updatedAt)
                .toLocaleString("en-US", {
                  timeZone: "America/New_York",
                  weekday: "short",
                  year: "numeric",
                  month: "short",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true
                })
                .replace(",", "")
                .replace(/(\d+:\d+ [APM]+)$/, "at $1")
            : ""}
        </Typography>
      </Box>
      <NotesSection buyerId={buyerId} />
      <Paper elevation={4} sx={{ p: 2, mt: 2 }}>
        <Grid2 container spacing={1}>
          <Grid2 size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
            <Dropdown
              label="Stage"
              value=""
              options={options}
              onChange={(event) => {
                console.log("Selected value:", event.target.value);
              }}
              helperText=""
              error={false}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
            <Dropdown
              label="Account Manager"
              value=""
              options={options}
              onChange={(event) => {
                console.log("Selected value:", event.target.value);
              }}
              helperText=""
              error={false}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
            <Dropdown
              label="Sales Representative"
              value=""
              options={options}
              onChange={(event) => {
                console.log("Selected value:", event.target.value);
              }}
              helperText=""
              error={false}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
            <Dropdown
              label="Mortgage Advisor"
              value=""
              options={options}
              onChange={(event) => {
                console.log("Selected value:", event.target.value);
              }}
              helperText=""
              error={false}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
            <Dropdown
              label="Zown Offer Agent"
              value=""
              options={options}
              onChange={(event) => {
                console.log("Selected value:", event.target.value);
              }}
              helperText=""
              error={false}
            />
          </Grid2>
        </Grid2>
      </Paper>

      <Paper elevation={4} sx={{ p: 2, mt: 2 }}>
        <Grid2 container spacing={1} sx={{ mt: 2 }}>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput
              label="First Name"
              value={buyerData.buyer.firstName || ""}
              onChange={(event) =>
                console.log("Input value:", event.target.value)
              }
              error={false}
              helperText=""
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput
              label="Last Name"
              value={buyerData.buyer.lastName || ""}
              onChange={(event) =>
                console.log("Input value:", event.target.value)
              }
              error={false}
              helperText=""
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput
              label="Email"
              value={buyerData.buyer.emailAddress}
              onChange={(event) =>
                console.log("Input value:", event.target.value)
              }
              error={false}
              helperText=""
            />
          </Grid2>
        </Grid2>
        <Grid2 container spacing={1} sx={{ mt: 1 }}>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput
              label="Address"
              value={`${buyerData.buyer.address ? `${buyerData.buyer.address?.address1}, ${buyerData.buyer.address?.city}, ${buyerData.buyer.address?.state}, ${buyerData.buyer.address?.postalCode}, ${buyerData.buyer.address?.country}` : ""}`}
              onChange={(event) =>
                console.log("Input value:", event.target.value)
              }
              error={false}
              helperText=""
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput
              label="Referral Code"
              value={buyerData.buyer.referralCode || ""}
              onChange={(event) =>
                console.log("Input value:", event.target.value)
              }
              error={false}
              helperText=""
            />
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput
              label="Profession"
              value={buyerData.buyer.profession || ""}
              onChange={(event) =>
                console.log("Input value:", event.target.value)
              }
              error={false}
              helperText=""
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput
              label="Phone #"
              value={
                buyerData.buyer.phoneNumber
                  ? formatPhoneNumber(buyerData.buyer.phoneNumber)
                  : ""
              }
              onChange={(event) =>
                console.log("Input value:", event.target.value)
              }
              error={false}
              helperText=""
            />
          </Grid2>
        </Grid2>
      </Paper>

      <Paper elevation={4} sx={{ p: 2, mt: 2 }}>
        <Typography variant="h5" gutterBottom>
          Financials
        </Typography>
        {buyerData.buyer.finances ? (
          <Grid2 container spacing={1}>
            <Grid2 size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
              <CurrencyInput
                label="Total Income"
                value={
                  buyerData.buyer.finances.income &&
                  buyerData.buyer.finances.income?.length > 0
                    ? formatPrice(
                        convertToFormattedAmount(
                          buyerData.buyer.finances.income[0].amount.amount
                        )
                      )
                    : ""
                }
                onChange={(value) => console.log("Input value:", value)}
                error={false}
                helperText=""
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
              <CurrencyInput
                label="Total Savings"
                value={
                  buyerData.buyer.finances.savings &&
                  buyerData.buyer.finances.savings?.length > 0
                    ? formatPrice(
                        convertToFormattedAmount(
                          buyerData.buyer.finances.savings[0].amount.amount
                        )
                      )
                    : ""
                }
                onChange={(value) => console.log("Input value:", value)}
                error={false}
                helperText=""
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
              <CurrencyInput
                label="Total Monthly Debt"
                value={
                  buyerData.buyer.finances.monthlyDebt &&
                  buyerData.buyer.finances.monthlyDebt?.length > 0
                    ? formatPrice(
                        convertToFormattedAmount(
                          buyerData.buyer.finances.monthlyDebt[0].amount.amount
                        )
                      )
                    : ""
                }
                onChange={(value) => console.log("Input value:", value)}
                error={false}
                helperText=""
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
              <CurrencyInput
                label="Affordability"
                value={
                  buyerData.buyer.finances.affordability
                    ? formatPrice(
                        convertToFormattedAmount(
                          buyerData.buyer.finances.affordability?.amount
                        )
                      )
                    : ""
                }
                onChange={(value) => console.log("Input value:", value)}
                error={false}
                helperText=""
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
              <CurrencyInput
                label="Down Payment Assistance"
                value={
                  buyerData.buyer.finances.downPaymentAssistance
                    ? formatPrice(
                        convertToFormattedAmount(
                          buyerData.buyer.finances.downPaymentAssistance?.amount
                        )
                      )
                    : ""
                }
                onChange={(value) => console.log("Input value:", value)}
                error={false}
                helperText=""
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
              <CurrencyInput
                label="Pre-Approved Amount"
                value={
                  buyerData.buyer.finances.preApprovals
                    ? formatPrice(
                        convertToFormattedAmount(
                          buyerData.buyer.finances.preApprovals.amount.amount
                        )
                      )
                    : ""
                }
                onChange={(value) => console.log("Input value:", value)}
                error={false}
                helperText=""
              />
            </Grid2>
          </Grid2>
        ) : (
          <Typography variant="body2" sx={{ color: "gray" }}>
            No Financials Found
          </Typography>
        )}
      </Paper>
      {/* <Paper elevation={4} sx={{ p: 2, mt: 2 }}>
          <Typography variant="h5" gutterBottom>
            Tracking
          </Typography>
          <TableContainer component={Paper} sx={{ my: 2 }}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  {
                    key: "INITIAL_CAMPAIGN",
                    name: "Initial Campaign",
                    value: "-"
                  },
                  {
                    key: "INITIAL_CAMPAIGN_ID",
                    name: "Initial Campaign ID",
                    value: "-"
                  },
                  {
                    key: "INITAL_VARIENT",
                    name: "Initial Website Variation",
                    value: "-"
                  },
                  {
                    key: "Form_Submission",
                    name: "Form ID",
                    value: "-"
                  }
                ].map((row) => (
                  <TableRow
                    key={row.key}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 }
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell>{row.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid2 container spacing={1} sx={{ mt: 2 }}>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 3 }}>
              <TextInput
                label="Zown ID"
                value={buyerData.id}
                onChange={(event) => {
                  console.log("Input value:", event.target.value);
                }}
                error={false}
                helperText=""
                disabled={true}
              />
            </Grid2>
          </Grid2>
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2" sx={{ color: "gray" }}>
              <strong>Created At:</strong>{" "}
              {moment(buyerData.createdAt).format("L")}
            </Typography>
            <Typography variant="body2" sx={{ color: "gray" }}>
              <strong>Last Updated:</strong>{" "}
              {moment(buyerData.updatedAt).format("L")}
            </Typography>
          </Box>
        </Paper> */}
      {buyerData.outings && buyerData.outings.length > 0 && (
        <OutingsInfo outings={buyerData.outings} />
      )}

      <Paper elevation={4} sx={{ p: 3, mt: 3 }}>
        <Typography variant="h5" gutterBottom>
          Cart Properties
        </Typography>
        {buyerData.buyer.cart ? (
          <ListingTable listings={buyerData.buyer.cart} />
        ) : (
          <Typography variant="body2" sx={{ color: "gray" }}>
            No Cart Properties Found
          </Typography>
        )}
      </Paper>

      <Paper elevation={4} sx={{ p: 3, mt: 3 }}>
        <Typography variant="h5" gutterBottom>
          Liked Properties
        </Typography>

        {buyerData.buyer.likedHomes ? (
          <ListingTable listings={buyerData.buyer.likedHomes} />
        ) : (
          <Typography variant="body2" sx={{ color: "gray" }}>
            No Liked Properties Found
          </Typography>
        )}
      </Paper>
    </Box>
  );
};
